/*!
 * progress-promise-proxy v0.10.2 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { createProxy } from '@aspectus/promise-proxy';

var main = createProxy({
  progress: function progress(callback) {
    if (this.$data.progressEmitter && this.$data.progressEmitter.on) {
      return this.$data.progressEmitter.on('progress', callback);
    }

    return this;
  }
});

export default main;
